import { render, staticRenderFns } from "./WellbeingStudio.vue?vue&type=template&id=48324c4e"
import script from "./WellbeingStudio.vue?vue&type=script&lang=js"
export * from "./WellbeingStudio.vue?vue&type=script&lang=js"
import style0 from "./WellbeingStudio.vue?vue&type=style&index=0&id=48324c4e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports